<div class="datepicker datepicker--has-ranges">
  <div class="datepicker__calendar">
    <!--Previous month-->
    <a
      class="datepicker__nav datepicker__nav--previous"
      (click)="goToPreviousMonth()"
    >
      <ta-icon icon="left-dir"></ta-icon>
    </a>

    <!--Next month-->
    <a class="datepicker__nav datepicker__nav--next" (click)="goToNextMonth()">
      <ta-icon icon="right-dir"></ta-icon>
    </a>

    <!--Dates-->
    <table class="calendar" *ngFor="let month of months">
      <tr class="calendar__header">
        <td colspan="7" class="calendar__month" (click)="selectMonth(month)">
          {{ month.startDate | date:'MMM yyyy' }}
        </td>
      </tr>

      <tr class="calendar__weeks">
        <td class="calendar__day">S</td>
        <td class="calendar__day">M</td>
        <td class="calendar__day">T</td>
        <td class="calendar__day">W</td>
        <td class="calendar__day">T</td>
        <td class="calendar__day">F</td>
        <td class="calendar__day">S</td>
      </tr>

      <tr class="calendar__week" *ngFor="let week of month.weeks">
        <td
          class="calendar__date"
          [ngClass]="{
						'calendar__date--selectable': day.visible,
						'calendar__date--selected': day.selected,
						'calendar__date--first-selected': day.firstSelected,
						'calendar__date--last-selected': day.lastSelected
					}"
          *ngFor="let day of week"
          (mouseover)="hoverDates(day)"
          (click)="selectDate(day)"
        >
          <span *ngIf="day.visible">{{ day.dateIso | date:'d' }}</span>
        </td>
      </tr>
    </table>
  </div>

  <div class="datepicker__controls">
    <div class="datepicker__inputs">
      <!-- YOU WERE HERE, TRYING TO FIGURE OUT HOW TO HANDLE DATE INPUT
			WITHOUT TRIGGERING CHANGE EVENTS EVERY TIME THE USER TYPES -->

      <input
        type="text"
        class="datepicker__input"
        name="startDateFormatted"
        #startDate
        (blur)="dateBlur()"
        [(ngModel)]="startDateFormatted"
      />
      <input
        type="text"
        class="datepicker__input"
        name="endDateFormatted"
        #endDate
        (blur)="dateBlur()"
        [(ngModel)]="endDateFormatted"
        *ngIf="!single"
      />
    </div>

    <!--Range Picker-->
    <div class="datepicker__ranges">
      <a class="datepicker__range" (click)="selectToday()">Today</a>
      <a class="datepicker__range" (click)="selectLast7Days()" *ngIf="!single"
        >Last 7 days</a
      >
      <a class="datepicker__range" (click)="selectLast30Days()" *ngIf="!single"
        >Last 30 days</a
      >
      <a class="datepicker__range" (click)="selectWeekToDate()" *ngIf="!single"
        >Week to date</a
      >
      <a class="datepicker__range" (click)="selectMonthToDate()" *ngIf="!single"
        >Month to date</a
      >
    </div>
  </div>
</div>
